import { useLocation } from 'react-router-dom';

export const useEmbedded = () => {
  const location = useLocation();
  return location.pathname.startsWith('/embed');
};